import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { CajaApertura } from "@/shared/types/caja-apertura";

export async function getCajaActualApertura(id: string): Promise<CajaApertura> {
    await sleep(1000);
    const response = await api.get("caja_actual/history/" + id);
    return response.data;
}

export function useGetCajaActualAperturaQuery(id: string, queryConfig: QueryConfig<CajaApertura> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getCajaActualApertura(id),
        queryKey: ["caja_actual", "history", id],
    })
}

export interface GetCajaActualAperturaQueryProps {
    id: string,
    queryConfig?: QueryConfig<CajaApertura>,
    children?: (queryResult: QueryResult<CajaApertura>) => ReactNode
}

export function GetCajaActualAperturaQuery({
    id,
    children,
    queryConfig
}: GetCajaActualAperturaQueryProps) {
    const queryResult = useGetCajaActualAperturaQuery(id, queryConfig);
    return children && children(queryResult);
}